"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MoreHoriz = _interopRequireDefault(require("@material-ui/icons/MoreHoriz"));
var _excluded = ["className", "onClick"];
var _default = exports["default"] = function _default(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('inline-flex items-center overflow-hidden text-gray-medium bg-gray-divider', 'rounded-full hover:shadow h-3 px-1 cursor-pointer my-2 leading-loose', className),
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement(_MoreHoriz["default"], null));
};
//# sourceMappingURL=CollapseAction.js.map